<h1 mat-dialog-title>
    Error Missing Case
</h1>
<div mat-dialog-content>
    Case could not be found, please go back to case history and try searching for this case again
</div>
<div class="actions">
    <button mat-raised-button [routerLink]="'/case/'" (click)="close()">Go Back</button>
</div>